export interface LanguageI {
  id: string;
  name: string;
}

export const makeLanguageI = (id: string, name: string): LanguageI => {
  return { id, name };
};
